// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"41":"error","1189":"editor","5872":"version","6242":"project","7715":"waitlist"}[chunkId] + "." + {"41":"25148428","1189":"fad3fd33","5872":"e7693444","6242":"d65ac838","7715":"345c0d84"}[chunkId] + ".css";
};